import {Routes, WebsitePath} from '~/utils/routes'
import {AppPath} from '~/utils/routes.app'

type CommonNavItem = {
  id: number
  label: string
}
type NavItem = CommonNavItem &
  ({isAppUrl: true; link: AppPath} | {isAppUrl?: false; link: WebsitePath})
export const navItems: NavItem[] = [
  {
    id: 1,
    label: Routes.TRANSLATE.name,
    link: Routes.TRANSLATE.path
  },
  {
    id: 2,
    label: Routes.ABOUT.name,
    link: Routes.ABOUT.path
  },
  {
    id: 3,
    label: 'nav_pages.pricing',
    link: '/pricing',
    isAppUrl: true
  }
]
